<template>
	<div class="result empty no-link">
		<a>
			<span>{{__('no_search_results')}}</span>
		</a>
	</div>
</template>

<script>
export default {
	name : 'EmptyResult',
	props : ['result'],
	data : function(){
		return {

		}
	}
}
</script>
